import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Sign-in cookies only work on the API's own address, so send visitors from other addresses (e.g. www, emergent.host) there.
const HOME = new URL(process.env.REACT_APP_BACKEND_URL).origin;
const offHome = window.location.origin !== HOME && window.location.hostname !== "localhost";
if (offHome) window.location.replace(HOME + window.location.pathname + window.location.search + window.location.hash);

const root = ReactDOM.createRoot(document.getElementById("root"));
if (!offHome) root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
